import axios from '@/jslib/axios'

export const getCampaignCodeList = params => {
  return axios({
    method: 'get',
    url: '/admin/campaign/code/list',
    params
  })
}
export const getHanbergCashbackList = params => {
  return axios({
    method: 'get',
    url: '/admin/hanberg/cash/back/list',
    params
  })
}
export const getHanbergCashbackExportList = params => {
  return axios({
    method: 'get',
    url: '/admin/hanberg/cash/back/export/list',
    params,
    responseType: 'blob',
  })
}
